import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation";
import { useState, useEffect } from "react";
import { STICKY_SIDEBAR_TOP_PX } from "../../constants/stickyNav.esm.js";
import B2BFooter from "../B2BFooter/B2BFooter.esm.js";
import B2BMainNav from "../B2BMainNav/B2BMainNav.esm.js";
import B2BSubnav from "../B2BSubnav/B2BSubnav.esm.js";
import B2BUserNav from "../B2BUserNav/B2BUserNav.esm.js";
import ContactSalesModal from "../ContactSalesModal/ContactSalesModal.esm.js";
const B2B_HEADER_ID = "b2b-layout-header";
const HIDE_HEADER_SCRIPT = `
(function(){
  var p = new URLSearchParams(window.location.search);
  if(p.has('fromApp')){
    var style = document.createElement('style');
    style.id = 'hide-b2b-header-style';
    style.textContent = '#${B2B_HEADER_ID}{display:none!important}';
    document.head.appendChild(style);
  }
})();
`;
const B2BLayout = (props) => {
  const {
    children,
    env = "prod"
  } = props;
  const [mobileMenu, setMobileMenu] = useState(false);
  const [subnavOpen, setSubnavOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    if (!props.sticky) {
      return;
    }
    const onScroll = () => {
      setIsSticky(window.scrollY > window.innerHeight / 2);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [props.sticky]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("script", { dangerouslySetInnerHTML: {
      __html: HIDE_HEADER_SCRIPT
    } }),
    props.sticky && /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: {
      __html: `
                            html {
                                scroll-padding-top: ${STICKY_SIDEBAR_TOP_PX}px;
                            }
                        `
    } }),
    /* @__PURE__ */ jsxs(Box, { id: B2B_HEADER_ID, sx: {
      margin: "0 auto",
      position: "relative",
      ...props.transparent && !isSticky && {
        position: "absolute",
        width: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: "$zIndices.modal"
      }
    }, children: [
      !props.disabled && /* @__PURE__ */ jsx(B2BUserNav, { redirectParam: props.signInRedirectParam, router: props.router, transparent: props.transparent && !mobileMenu, env, signInLink: props.signInLink, userMenuItems: props.userMenuItems }),
      /* @__PURE__ */ jsx(B2BMainNav, { logo: props.logo, disabled: props.disabled, transparent: props.transparent && !mobileMenu && !isSticky, sticky: isSticky, menu: props.menu, mobileMenu, setMobileMenu: (isOpen) => {
        setMobileMenu(isOpen);
        if (isOpen) {
          setSubnavOpen(false);
        }
      }, primaryCTALabel: props.primaryCTALabel, primaryCTALink: props.primaryCTALink, secondaryCTALabel: props.secondaryCTALabel, secondaryCTALink: props.secondaryCTALink, secondaryCTAModal: props.secondaryCTAModal }),
      !props.transparent && (props.subnavPrimaryItem || props.subnavItems) && /* @__PURE__ */ jsx(B2BSubnav, { primaryItem: props.subnavPrimaryItem, items: props.subnavItems, searchPlaceholder: props.searchPlaceholder, searchPrefix: props.searchPrefix, isOpen: subnavOpen, onOpenChange: (isOpen) => {
        setSubnavOpen(isOpen);
        if (isOpen) {
          setMobileMenu(false);
        }
      } })
    ] }),
    children,
    /* @__PURE__ */ jsx(ContactSalesModal, {}),
    /* @__PURE__ */ jsx(B2BFooter, { disabled: props.disabled, columns: props.footerColumns, logo: props.logo })
  ] });
};
export {
  B2BLayout as default
};
